import React from "react";
import { View, Text, ActivityIndicator } from "react-native";
import tw from "twrnc";

interface CenteredMessageProps {
  title: string;
  subtitle?: string;
  error?: boolean;
}

const CenteredMessage: React.FC<CenteredMessageProps> = ({
  title,
  subtitle,
  error = false,
}) => (
  <View
    style={tw`flex-1 bg-[#070816] px-6 pt-10 justify-center items-center`}
    data-oid="9tc0xsx"
  >
    {error ? null : (
      <ActivityIndicator size="large" color="#F7C948" data-oid="o5iw-6a" />
    )}
    <Text
      style={tw`text-lg mt-4 text-center font-semibold ${error ? "text-[#FCA5A5]" : "text-[#FFE89A]"}`}
      data-oid="q.xl9:l"
    >
      {title}
    </Text>
    {!!subtitle && (
      <Text style={tw`text-base mt-2 text-[#F7EED7]/70 text-center`} data-oid="b3gsucg">
        {subtitle}
      </Text>
    )}
  </View>
);

export default CenteredMessage;
